import { CircularProgress } from '@mui/material';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Styles from './LoadingRow.module.scss';

function LoadingRow({ colSpan }: Readonly<{ colSpan: number }>): React.ReactElement {
    return (
        <TableRow id={Styles.LoadingRow}>
            <TableCell colSpan={colSpan} sx={{ textAlign: 'center' }}>
                <CircularProgress />
            </TableCell>
        </TableRow>
    );
}

export default LoadingRow;
